import { gql } from '@apollo/client'

export default gql(`
    mutation adminCreateSubscription($email: String!, $offerCode: String, $endDate: AWSDateTime!) {
        adminCreateSubscription(
            email: $email
            offerCode: $offerCode
            endDate: $endDate
        ) {
            success{
                message
            }
            error{
                message
            }
        }
    }`
)
